module.exports = ".top{background-color: #7b317e; color: #fff; padding-top: 20px; padding-bottom:20px;}\r\n.inner-logo{font-size: 24px;}\r\n.wallet{display: inline-block; margin: 0 10px; font-size: 15px;position: relative; top: 2px;}\r\n.display-b{float: right;}\r\n.font-10{font-size: 10px}\r\n.mrgn-top-7{margin-top: 7px;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.css
// module id = ./src/app/shared/header/header.component.css
// module chunks = main